import * as React from "react";
import {
  Dialog,
  Avatar,
  Box,
  Stack,
  Typography,
  IconButton
} from "@mui/material";
import CallEndRounded from "@mui/icons-material/CallEndRounded";
import CallRounded from "@mui/icons-material/CallRounded";

export default function CustomCallAlert({
  open = true,
  onClose,
  onAccept, 
  onDecline,
  name = "Amanpreet Kaur",
  subtitle = "Now Calling…",
  // avatarSrc removed - now using first letter of name
}) {
  // Auto-close after 3 seconds
  React.useEffect(() => {
    if (open && onClose) {
      const timer = setTimeout(() => {
        onClose();
      }, 5000); // 3 seconds

      return () => clearTimeout(timer);
    }
  }, [open, onClose]);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="call-dialog-title"
      aria-describedby="call-dialog-description"
      // Position the dialog at top right of the window
      PaperProps={{
        elevation: 8,
        sx: {
          position: 'fixed',
          top: '16px',
          right: '16px',
          transform: 'none',
          borderRadius: 999,
          p: 1.25,
          bgcolor: "#E9EAED",            // soft grey like the reference
          boxShadow:
            "0 8px 20px rgba(0,0,0,0.15), inset 0 1px 0 rgba(255,255,255,0.6)",
          // keep it small and compact
          width: 360,
          maxWidth: "90vw",
          animation: "heartbeat 1.5s ease-in-out infinite, vibrate 0.5s ease-in-out infinite",
          "@keyframes heartbeat": {
            "0%": {
              transform: "scale(1)",
              boxShadow: "0 8px 20px rgba(0,0,0,0.15), inset 0 1px 0 rgba(255,255,255,0.6)"
            },
            "50%": {
              transform: "scale(1.05)",
              boxShadow: "0 12px 25px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.6)"
            },
            "100%": {
              transform: "scale(1)",
              boxShadow: "0 8px 20px rgba(0,0,0,0.15), inset 0 1px 0 rgba(255,255,255,0.6)"
            },
          },
          "@keyframes vibrate": {
            "0%": { transform: "translateX(0)" },
            "25%": { transform: "translateX(-2px)" },
            "50%": { transform: "translateX(2px)" },
            "75%": { transform: "translateX(-1px)" },
            "100%": { transform: "translateX(0)" },
          },
        },
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1.25}>
        {/* Avatar */}
        <Avatar
          sx={{
            width: 40,
            height: 40,
            bgcolor: "#88beff",               // green background
            color: "#fff",                     // white text
            fontSize: "1.1rem",
            fontWeight: "bold",
            boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
            // animation: "avatarPulse 2s ease-in-out infinite",
            // "@keyframes avatarPulse": {
            //   "0%": { 
            //     boxShadow: "0 2px 6px rgba(0,0,0,0.25)" 
            //   },
            //   "50%": { 
            //     boxShadow: "0 4px 12px rgba(46,204,113,0.4)" 
            //   },
            //   "100%": { 
            //     boxShadow: "0 2px 6px rgba(0,0,0,0.25)" 
            //   },
            // },
          }}
        >
          {name.charAt(0).toUpperCase()}
        </Avatar>

        {/* Name + subtitle */}
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography
            id="call-dialog-title"
            variant="subtitle1"
            sx={{ fontWeight: 700, lineHeight: 1.1 }}
            noWrap
          >
            {name}
          </Typography>
          <Typography
            id="call-dialog-description"
            variant="caption"
            sx={{ color: "rgba(0,0,0,0.6)" }}
            noWrap
          >
            {subtitle}
          </Typography>
        </Box>

        {/* Decline */}
        {/* <IconButton
          aria-label="Decline"
          onClick={onDecline || onClose}
          sx={{
            width: 40,
            height: 40,
            borderRadius: "50%",
            bgcolor: "#E53935",                // red
            color: "#fff",
            boxShadow: "0 6px 12px rgba(229,57,53,0.45)",
            "&:hover": { bgcolor: "#D32F2F" },
            mr: 0.5,
          }}
        >
          <CallEndRounded />
        </IconButton> */}

        {/* Accept */}
        <IconButton
          aria-label="Accept"
          onClick={onAccept}
          sx={{
            width: 40,
            height: 40,
            borderRadius: "50%",
            bgcolor: "#2ECC71",               // green
            color: "#fff",
            boxShadow: "0 6px 12px rgba(46,204,113,0.45)",
            "&:hover": { bgcolor: "#27AE60" },
            // animation: "heartbeat 1.5s ease-in-out infinite, vibrate 0.5s ease-in-out infinite",
            // "@keyframes heartbeat": {
            //   "0%": {
            //     transform: "scale(1)",
            //     boxShadow: "0 8px 20px rgba(0,0,0,0.15), inset 0 1px 0 rgba(255,255,255,0.6)"
            //   },
            //   "50%": {
            //     transform: "scale(1.05)",
            //     boxShadow: "0 12px 25px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.6)"
            //   },
            //   "100%": {
            //     transform: "scale(1)",
            //     boxShadow: "0 8px 20px rgba(0,0,0,0.15), inset 0 1px 0 rgba(255,255,255,0.6)"
            //   },
            // },
            // "@keyframes vibrate": {
            //   "0%": { transform: "translateX(0)" },
            //   "25%": { transform: "translateX(-2px)" },
            //   "50%": { transform: "translateX(2px)" },
            //   "75%": { transform: "translateX(-1px)" },
            //   "100%": { transform: "translateX(0)" },
            // },
          }}
        >
          <CallRounded />
        </IconButton>
      </Stack>
    </Dialog>
  );
}
